import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Grid, Header, Icon, Item, Label, List, Segment } from 'semantic-ui-react';
import { CmsBlocks } from '../cms/CmsScreen';
import CdnImage from '../components/CdnImage';
import EntityLink from '../components/EntityLink';
import ItemCardGroup from '../components/ItemCardGroup';
import SponsorCard from '../components/sponsors/SponsorCard';
import { useScreenConfig } from '../config/screens.context';
import MenuFilter from '../core/filter/MenuFilter';
import { generateFilters } from '../core/filter/utils';
import store from '../shared/Store';
import { getString, throttleDispatchFetch } from '../utils';
import { useFilter, useOrderBy } from '../utils/hooks';
import { fetchSponsors } from './store/sponsors.actions';

const translationPrefix = 'sponsors';

const throttledFetch = throttleDispatchFetch(() => store.reduxStore.dispatch(fetchSponsors()));

// const recommendedWorkshops = [workshops[0], workshops[2]];
// export const registeredWorkshops = workshops.slice(3, 5);

export const SponsorSmallItem = ({ sponsor }) => (
  <List.Item>
    <CdnImage avatar src={sponsor.logo} />
    <List.Content>
      <List.Header as={EntityLink} entity={sponsor}>
        {sponsor.name}
      </List.Header>
      <List.Description>
        <Label>{sponsor.tag}</Label>
      </List.Description>
    </List.Content>
  </List.Item>
);

SponsorSmallItem.propTypes = {
  sponsor: PropTypes.object.isRequired,
};

const colors = {
  platinum: 'blue',
  gold: 'yellow',
  silver: 'grey',
};

export const SponsorItem = ({ sponsor }) => (
  <Item>
    <Item.Image size="small" src={sponsor.logo} />
    <Item.Content>
      <Item.Header as={EntityLink} entity={sponsor}>
        {sponsor.name}
      </Item.Header>
      <Item.Extra>
        <Label icon="tag" content={sponsor.tag} />
      </Item.Extra>
      <Item.Meta>{getString(`${translationPrefix}.description`)}</Item.Meta>
      <Item.Description>{sponsor.description}</Item.Description>
      <Item.Extra>
        <Button primary floated="right" as={EntityLink} entity={sponsor}>
          {getString(`${translationPrefix}.book-a-meeting`)}
          <Icon name="right chevron" />
        </Button>
        <Label icon="trophy" color={colors[sponsor.category]} content={sponsor.category} />
      </Item.Extra>
    </Item.Content>
  </Item>
);

SponsorItem.propTypes = {
  sponsor: PropTypes.object.isRequired,
};

const defaultOrder = [
  { field: 'order', order: 'asc' },
  { field: 'name', order: 'asc' },
];

const Sponsors = ({ mode, sponsors }) => {
  const {
    filters: fieldsToFilter = [],
    groupBy,
    orderBy: orderByConfig = defaultOrder,
    header,
    footer,
  } = useScreenConfig('sponsors');

  const [filteredData, currentFilters, setFilters] = useFilter(sponsors, fieldsToFilter);
  const finalSponsors = useOrderBy(filteredData, orderByConfig);

  useEffect(() => {
    throttledFetch();
  }, []);

  return (
    <>
      {header && <CmsBlocks blocks={header.blocks} />}
      <Grid>
        <Grid.Column width={4}>
          <div style={{ paddingBottom: 10 }}>
            <MenuFilter
              filterList={generateFilters(sponsors, fieldsToFilter, currentFilters)}
              filters={currentFilters}
              onChange={setFilters}
            />
          </div>
        </Grid.Column>
        {mode === 'grid' && (
          <Grid.Column width={12}>
            <ItemCardGroup
              groupClassName="sponsors"
              items={finalSponsors}
              groupBy={groupBy}
              component={SponsorCard}
            />
          </Grid.Column>
        )}
        {mode === 'list' && (
          <>
            <Grid.Column width={8}>
              <Segment>
                <Header as="h3">
                  {finalSponsors.length} {getString(`${translationPrefix}.sponsors`)}
                </Header>
                <Item.Group divided>
                  {finalSponsors.map((item) => (
                    <SponsorItem key={item._id} sponsor={item} />
                  ))}
                </Item.Group>
              </Segment>
            </Grid.Column>
            {/* <Grid.Column width={4}>
            <Segment>
              <Header as="h3">Recommended for you</Header>
              <List divided relaxed>
                {recommended.map((item) => (
                  <SponsorSmallItem key={item._id} sponsor={item} />
                ))}
              </List>
            </Segment>
          </Grid.Column> */}
          </>
        )}
      </Grid>
      {footer && <CmsBlocks blocks={footer.blocks} />}
    </>
  );
};

Sponsors.defaultProps = {
  mode: 'grid',
  sponsors: [],
};

Sponsors.propTypes = {
  sponsors: PropTypes.arrayOf(PropTypes.object),
  mode: PropTypes.oneOf(['grid', 'list']),
};

const mapStateToProps = (state) => ({
  ...state.workshops,
  ...state.sponsors,
});

export default connect(mapStateToProps)(Sponsors);
